import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { diversifiers } from '@/react-query/queries/ic-report/hooks'

export interface DiversifiersScenarioChartProps extends ICReportChartPrimitive {}

export const DiversifiersScenarioChart: React.FC<DiversifiersScenarioChartProps> = ({
  params,
  options,
}) => {
  const query = diversifiers.useHistoricalEventsNew(params)
  const data = query.data

  const mergedOptions: AgChartOptions<NonNullable<typeof data>['data'][number]> = {
    data: data?.data ?? [],
    height: 500,
    series: [
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_tmo',
        yName: 'Return T-1',
      },
      {
        type: 'bar',
        xKey: 'shock_name',
        yKey: 'return_t',
        yName: 'Return',
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
        paddingInner: 0.5,
      },
      {
        type: 'number',
        position: 'left',
        interval: {
          minSpacing: 20,
        },
        label: {
          formatter: function (params) {
            return `${(params?.value * 100).toFixed(2)}%`
          },
        },
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
